import React from 'react';
import { reduxForm, Field, FormSection, formValueSelector } from 'redux-form';
import FormField from '../../../forms/FormField';
import { Button, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

const UploadFileForm = props => {
  const {
    handleSubmit,
    pristine,
    reset,
    submitting,
    change,
    fileValues,
    uploadFileErrors,
    inProgress
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row className="fileupload">
        <Col sm={6}>
          <Field
            name="files"
            component={FormField.FileInput}
            type="file"
            change={change}
            disabled={inProgress}
          />
        </Col>

        <Col sm={6}>
          {fileValues &&
            Array.isArray(fileValues) &&
            <div>
              <table className="table">
                <thead>
                  <tr>
                    <th>Filename</th>
                    <th className="text-right">File Type</th>
                    <th className="text-right">Size</th>
                  </tr>
                </thead>
                <tbody>
                  {fileValues.map((file, idx) => (
                    <tr>
                      <td>
                        <Field
                          name={`filenames[${idx}]`}
                          type="text"
                          component={FormField.Input}
                          disabled={inProgress}
                        />
                      </td>
                      <td className="text-right">{file.type}</td>
                      <td className="text-right">{file.size}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {uploadFileErrors &&
                <div>
                  {uploadFileErrors.message ||
                    'An error occurred uploading files'}
                  {uploadFileErrors.jsonData &&
                    (uploadFileErrors.jsonData.duplicates || []).length > 0 &&
                    <div>
                      {uploadFileErrors.jsonData.duplicates.map(duplicate => (
                        <div key={duplicate._id}>
                          {duplicate.filename}
                        </div>
                      ))}
                    </div>}
                </div>}
              <div>
              <div className="text-right">
                <Button
                  type="button"
                  bsStyle="hollow-info"
                  disabled={pristine || inProgress}
                  onClick={reset}
                >
                  <span className="ti ti-close" /> Clear Values
                </Button>
                {' '}
                <Button
                  bsStyle="success"
                  type="button"
                  onClick={handleSubmit}
                  disabled={inProgress}
                >
                  <span className="ti ti-check" /> Submit
                </Button>
              </div>
            </div>
          </div>}
        </Col>
      </Row>
    </form>
  );
};

const selector = formValueSelector('upload-file-form');

const form = reduxForm({
  form: 'upload-file-form' // a unique identifier for this form
  // validate,                // <--- validation function given to redux-form
  // warn                     // <--- warning function given to redux-form
})(UploadFileForm);

export default connect(state => {
  const fileValues = selector(state, 'files');
  const {
    error: uploadFileErrors,
    inProgress
  } = state.uploadFile.toJS();
  return {
    fileValues,
    uploadFileErrors,
    inProgress
  };
})(form);



// WEBPACK FOOTER //
// ./src/components/routes/files/forms/UploadFileForm.js